import { getAPI } from '../config';
import { COMMAND_STATUS, CONTEXT, TERMINAL_DOMAIN } from '../../../application/src/domain';
import { getAuthorizationConfig } from '../../src/config';
let apitoken = null;
export const getApiToken = () => apitoken;
export const setApiToken = (v) => {
    apitoken = v;
};
const getAuthHeader = async () => {
    let token = null;
    if (apitoken) {
        const config = getAuthorizationConfig();
        token = await apitoken(config.apiscope);
    }
    return {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            context: window.localStorage.getItem(CONTEXT) || TERMINAL_DOMAIN,
        },
    };
};
const parseJsonSafely = async (res) => {
    const raw = await res.text();
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch {
        return null;
    }
};
const handleResponse = async (res) => {
    if (res.status === 401) {
        window.location.href = `/`;
        return null;
    }
    if (res.status === 404 || res.status === 500) {
        return null;
    }
    return res !== null ? parseJsonSafely(res) : [];
};
const handleResponseException = async (res) => {
    if (res.status === 401) {
        window.location.href = `/`;
        return null;
    }
    else if (res.status === 404 || res.status === 500) {
        const r = await parseJsonSafely(res);
        throw new Error((r === null || r === void 0 ? void 0 : r.msg) || `Request failed with status ${res.status}`);
    }
    else {
        return res !== null ? parseJsonSafely(res) : [];
    }
};
const service = {
    get: async (url, options) => {
        const authheader = await getAuthHeader();
        const payload = { ...options, ...authheader /*credentials: 'include'*/ };
        return fetch(getAPI() + url, payload).then(handleResponse);
    },
    post: async (url, body, options = {}) => {
        const authheader = await getAuthHeader();
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'POST',
            body: JSON.stringify(body),
        }).then(handleResponse);
    },
    put: async (url, body, options = {}) => {
        const authheader = await getAuthHeader();
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'PUT',
            body: JSON.stringify(body),
        }).then(handleResponse);
    },
    delete: async (url, options = {}) => {
        const authheader = await getAuthHeader();
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'DELETE',
        }).then(handleResponse);
    },
};
export async function getRemotes() {
    return service.get(`/remotes`, {});
}
export async function getApplicationConfig() {
    return service.get(`/ConfigService`, {});
}
export async function createProject(data) {
    return service.post('/ModelService/projects', data, {});
}
export async function getNameAvailable(projectName) {
    return service.get(`/ModelService/nameavailable/${projectName}`, {});
}
export async function queryProjects(page, pageSize, term, status, tag) {
    return service.get(`/ModelService/projects?page=${page}&pageSize=${pageSize}&term=${term}&status=${status}&tag=${tag}`, {});
}
export async function deleteProject(id) {
    try {
        return service.delete(`/ModelService/project/${id}`, {});
    }
    catch (e) {
        console.log(e);
        return { msg: e, status: COMMAND_STATUS.FAILED };
    }
}
export async function getProject(id) {
    return service.get(`/ModelService/project/${id}`, {});
}
export async function createCategory(data) {
    return service.post('/ModelService/categories', data, {});
}
export async function queryCategories() {
    return service.get(`/ModelService/categories`, {});
}
